import { type CountryCode } from '@jsmdg/countries-ts/dist/models/country-code-enum';
import { countriesDE } from '@jsmdg/countries-ts/dist/translations/countriesDE';

export function getCountryByCountryCode(countryCode: keyof typeof CountryCode): string {
    return countriesDE[countryCode];
}
